export { default as useEdIndexQuery } from './useEdIndexQuery';
